var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value != null)?_c('div',{staticClass:"d-flex"},[_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.name)+" ")])]),_c('div',{staticClass:"ml-auto"},[_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }